export default "__VITE_ASSET__hFSoU0zc__";